import fetch from '../../../../core/fetch';
import showToaster from '../../../../helpers/toasterMessages/showToaster';

async function submit(values, dispatch) {
  const query = `
  mutation (
    $benefitsTitle1: String,
    $benefitsContent1: String,
    $benefitsTitle2: String,
    $benefitsContent2: String,
    $benefitsTitle3: String,
    $benefitsContent3: String,
    $benefitImage: String,
) {
  updateWhyHostPage (
    benefitsTitle1: $benefitsTitle1,
    benefitsContent1: $benefitsContent1,
    benefitsTitle2: $benefitsTitle2,
    benefitsContent2: $benefitsContent2,
    benefitsTitle3: $benefitsTitle3,
    benefitsContent3: $benefitsContent3,
    benefitImage: $benefitImage,
  ) {
      status
  }
}

  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables: values
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data.updateWhyHostPage.status === "success") {
    showToaster({ messageId: 'updateWhyHostPage', toasterType: 'success'})
  } else {
    showToaster({ messageId: 'updateWhyHostPageFailed', toasterType: 'error' })
  }

}

export default submit;
